import { useContext } from "react";

import { useHistory, useLocation } from 'react-router-dom';

import { AuthContext } from "@meddbriefer/mdb-auth";
import { useHeader } from "./HeaderContext";

const Header = () => {
	const history = useHistory()
	let location = useLocation()
	const { currentUser, signOutUser } = useContext(AuthContext)
	const {title} = useHeader()

	return (
		<header className="title-bar">
		<h1 onClick={() => history.push('/')}>MDBedit</h1>
		{!!title && <h2>{title}</h2>}
		<nav>
			{location.pathname !== '/' &&
			<button type="button" className="home-bttn" onClick={() => history.push('/')}>Home</button>}

			{currentUser &&
			<button type="button" className="sign-out-bttn" onClick={() => signOutUser()}>Sign Out</button>}
		</nav>
		</header>
	)
}

export default Header